<template>
  <div id="app" class="bg-info">
    <ul id="menu_btns">
      <li class="hb">
        <img :src="world_logo" alt="world_logo">
      </li>
      <li class="hb">
        <router-link to="/main_menu" class="header_link_btn">
          <font-awesome-icon icon="angle-double-right" />
          <span>Top</span>
        </router-link>
      </li>
      <li class="hb">
        <router-link to="/japan" class="header_link_btn">
          <font-awesome-icon icon="angle-double-right" />
          <span>{{ toJapanTitle }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 *  世界編 ヘッダ部
 * 
 * @vue-data {Object} [world_logo] 左端のロゴ
 * @vue-data {String} [toJapanTitle] 日本編へのリンクボタンのラベルテキスト
 * @vue-computed {Number} currentViewWidth 画面の幅
 */
export default {
  name: "WorldHeaderView",

  data () {
    return {
      world_logo: require("../assets/world_logo.png"),
      toJapanTitle: "日本がわかるトランプ"
    }
  },

  mounted () {
    this.changeLabels()
  },

  computed: {
    currentViewWidth () {
      return this.$store.getters.currentViewWidth
    }
  },

  watch: {
    currentViewWidth () {
      this.changeLabels()
    }
  },

  methods: {
    /**
     * 日本編メニューへ移動
     */
    toJapan () {
      this.$router.push("japan")
    },

    /**
     * 画面サイズに応じてリンクボタンのテキスト・左端のロゴを変更
     */
    changeLabels () {
      if (this.currentViewWidth < 550) {
        this.world_logo = require("../assets/world_logo_mini.png")
        this.toJapanTitle = "日本編"
      } else {
        this.world_logo = require("../assets/world_logo.png")
        this.toJapanTitle = "日本がわかるトランプ"
      }
    }
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#app
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #29292A
  height: 56px
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center

.bg-info 
  background-color: #2E446D !important

#menu_btns
  width: 100%
  margin: 10px
  padding: 0
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center
  flex-wrap: wrap

li:first-child
   margin-right: auto

img
  max-height: 30px

span
  margin-left: 8px

.hb
  height: 30px
  min-width: 80px
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center

a
  text-decoration: none
</style>
